import { t } from 'ember-intl';
import pageTitle from 'ember-page-title/helpers/page-title';
import PageHeader from 'tio-ui/components/page-header';
import ScheduledExportsPage from 'tio-reporting/components/scheduled-exports-page';
import { VStack } from 'tio-ui/components/layout';
import type { TOC } from '@ember/component/template-only';

interface S {
  Args: {
    model: {
      companyId?: string;
    };
  };
}

/**
 * Partner scheduled-export history. Grouped schedule → its runs, and read-only:
 * schedules are created and managed in tio-admin only.
 */
const ReportingExportsRoute: TOC<S> = <template>
  {{pageTitle (t "reporting.scheduled_exports")}}
  <VStack>
    <PageHeader @a11yTitle={{t "reporting.scheduled_exports"}} @sticky={{false}} />
    {{#if @model.companyId}}
      <ScheduledExportsPage
        @companyId={{@model.companyId}}
        @backRoute="authenticated.admin.reporting.index"
        @groupBySchedule={{true}}
      />
    {{/if}}
  </VStack>
</template>;

export default ReportingExportsRoute;
